import {ShippingSizeData} from './data';
import {ProductState, ViewProduct} from './i';
import s from './s';

export function updateShippingBoxID() {
    let id = -1;
    if (s.pcs.docWidth > s.pcs.docHeight) {
        const _t = s.pcs.docHeight;
        s.pcs.docHeight = s.pcs.docWidth;
        s.pcs.docWidth = _t;
    }

    try {
        let hit = false;
        for (let i = 0; i <= ShippingSizeData.length; i++) {
            let ssd = ShippingSizeData[i];
            if (s.pcs.docWidth <= ssd.width && s.pcs.docHeight <= ssd.height) {
                id = ssd.id;
                hit = true;
                break;
            }
        }
        if (hit === false) {
            id = 7;
        }
    } catch (e) {
        // err(e);
        id = 1;
    }

    let box_id: number = 3;
    if (s.prod.isShippingOversize) {
        switch (id) {
            case 1:
                box_id = 3;
            case 2:
            case 3:
                box_id = 4;
            case 4:
            case 5:
                box_id = 5;
            case 6:
                box_id = 6;
            default:
                box_id = 6;
        }
    } else {
        switch (id) {
            case 1:
                box_id = 1;
            case 2:
            case 3:
                box_id = 2;
            case 4:
            case 5:
                box_id = 3;
            case 6:
                box_id = 4;
            default:
                box_id = 5;
        }
    }
    s.ui.box_id = box_id;
}
